<ng-container *ngIf="showResults">
    <h2>Customer Results ({{ resultTotalCount }})</h2>
    <p-table #dt
             styleClass="search__individual"
             [value]="data.results"
             [globalFilterFields]="['customerName','customerNumber','displayAddress', 'dateOfBirth','sortIdentification','legacyCustomerNumber','legacySequenceNumber']"
             [rows]="10"
             [paginator]="true"
             sortMode="multiple"
             [multiSortMeta]="[{ field: 'customerName', order: 1 }, { field: 'customerNumber', order: 1 }]"
             expandableRows="true"
             (onRowExpand)="showNames($event)"
             (onRowCollapse)="hideNames($event)"
             dataKey="customerNumber">
        <ng-template pTemplate="caption">
            <div class="row">
                <div class="col-sm-6 col-md-3">
                    <input class="mvd_form-control" type="text" autocomplete="off" placeholder="Filter..." (input)="dt.filterGlobal($event.target.value, 'contains')">
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="9 + (!!showSelect ? 1 : 0)">
                    No records found
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th class="w--arrow"></th>
                <th class="w--photo"></th>
                <th pSortableColumn="customerName">Customer Name <p-sortIcon field="businessUnit"></p-sortIcon></th>
                <th pSortableColumn="customerNumber">Customer ID<p-sortIcon field="businessUnit"></p-sortIcon></th>
                <th pSortableColumn="displayAddress">Physical Address<p-sortIcon field="businessUnit"></p-sortIcon></th>
                <th pSortableColumn="dateOfBirth">DOB<p-sortIcon field="dateOfBirth"></p-sortIcon></th>
                <th pSortableColumn="sortIdentification">SSN/EIN/OIN<p-sortIcon field="sortIdentification"></p-sortIcon></th>
                <th pSortableColumn="legacyCustomerNumber">Leg Cust #<p-sortIcon field="legacyCustomerNumber"></p-sortIcon></th>
                <th pSortableColumn="legacySequenceNumber">Leg Seq #<p-sortIcon field="legacySequenceNumber"></p-sortIcon></th>
                <th [hidden]="!showSelect" class="w--icon">Select</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-expanded="expanded" let-data>
            <tr [pSelectableRow]="data">
                <td>
                    <a href="javascript:void(0)" [pRowToggler]="data">
                        <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                    </a>
                </td>
                <td class="td--photo">
                    <customer-photo [classes]="'mvd_photo'" [customerNumberId]="data.customerNumber" [legacySequenceNumber]="data.legacySequenceNumber"></customer-photo>
                </td>
                <td class="td--hover-show"> <a href="javascript:void(0);" (click)="showCustomer(data.customerNumber)">{{ data.customerName }}</a></td>
                <td>{{ data.customerNumber }}</td>
                <td>
                    <div>{{ trimAddress(data.addressLine1) }}</div>
                    <div>{{ data.city }}, {{ data.jurisdictionCode }} {{ data.postalCode }}, {{ data.countyCode }}</div>
                </td>
                <td>{{ data.isRedactCustomer ? '*********' : data.dateOfBirth }}</td>
                <td>
                    <ng-container *ngIf="data.customerTypeId == 1">{{ data.ssn | ssn }}</ng-container>
                    <ng-container *ngIf="data.customerTypeId == 2">
                        <ng-container *ngIf="data.ein">{{ data.ein | ein}}</ng-container>
                        <ng-container *ngIf="!data.ein">{{ data.oin}}</ng-container>
                    </ng-container>
                </td>
                <td>{{ data.legacyCustomerNumber }}</td>
                <td>{{ data.legacySequenceNumber }}</td>
                <td class="text-center" [hidden]="!showSelect">
                    <a class="icon--select" title="Select" href="javascript:void(0);" (click)="selectCustomer(data.customerNumber)"></a>
                </td>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-data>
            <tr>
                <td [attr.colspan]="9 + (!!showSelect ? 1 : 0)">
                    <div class="search__aka">
                        <b>AKA Names</b>
                        <ul>
                            <li *ngFor="let name of data.akas">
                                {{ name }}
                            </li>
                        </ul>
                    </div>
                    <div class="search__dba">
                        <b>DBA Names</b>
                        <ul>
                            <li *ngFor="let name of data.dbas">
                                {{ name }}
                            </li>
                        </ul>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</ng-container>